import { useEffect, useState } from "react";
import { Zap } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

export const FlashBadge = ({ end, discount, className = "" }) => {
  const [left, setLeft] = useState(end - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(end - Date.now()), 1000);
    return () => clearInterval(t);
  }, [end]);
  if (left <= 0) return null;
  const h = Math.floor(left / 3.6e6);
  const m = Math.floor((left % 3.6e6) / 6e4);
  const s = Math.floor((left % 6e4) / 1000);
  return (
    <span
      data-testid="flash-badge"
      className={`flex items-center gap-1 rounded-full bg-terra px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-cream shadow-[0_0_18px_rgba(255,46,76,0.55)] ${className}`}
    >
      <Zap className="h-3 w-3" strokeWidth={2.5} /> Offerta lampo -{discount}% · {pad(h)}:{pad(m)}:{pad(s)}
    </span>
  );
};
